export default __webpack_public_path__ + "static/upgrade_web_portal-e60c4c403fbc82c90ef233a197f29dd0.webp";